















































































































import { Vue, Prop, Component } from "vue-property-decorator";
import { Employee as IEmployee } from "@/api/models/employee";
import api, { learningRequestApi } from "@/getinfo-api";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { AxiosError } from "axios";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import CustomButton from "@/components/form/CustomButton.vue";
import Modal from "@/components/form/Modal.vue";
import ListenerInRequestList from "@/components/orders/ListenerInRequestList.vue";
import CourseRegistrationsTable from "@/components/courses/CourseRegistrationsTable.vue";
import { getCurrentCompanyId } from "@/plugins/roles";
import { StatusProfile as IProfile } from "@/api-v2/learning-requests/models";
import StudentTable from "@/components/students/StudentTable.vue";
import StudentInfoTables from "@/components/students/StudentInfoTables.vue";
import students, { StudentsListParams } from "@/getinfo-api/students";

@Component({
  components: {
    StudentInfoTables,
    StudentTable,
    CourseRegistrationsTable,
    ListenerInRequestList,
    Modal,
    CustomButton,
    CustomTableCol,
    CustomTableItem
  }
})
export default class StudentOrderItemPreview extends Vue {
  modalId: string = this.generate();
  @Prop({ default: false }) contractTable!: boolean;
  @Prop({ default: false }) disableAction!: boolean;
  @Prop({ default: false }) isCheckable!: boolean;
  @Prop() request!: any;
  @Prop() index!: number;
  isDisable: boolean = this.disableAction;
  status!: string;
  profile!: IProfile;
  isStatusChanging: boolean = false;
  registrations!: any;
  students!: any;

  data() {
    return {
      registrations: undefined,
      students: undefined,
      status: undefined,
      profile: undefined
    };
  }

  async getProfile() {
    await learningRequestApi.StatusProfiles.getProfile(
      //@ts-ignore
      this.request.profileId
    ).then(res => {
      this.profile = res.data;
      //@ts-ignore
      this.status = this.request?.statusId;
    });
  }

  generate(): string {
    return Math.random()
      .toString(36)
      .substring(7);
  }

  get companyId(): string {
    return getCurrentCompanyId();
  }

  changeStatus() {
    this.isStatusChanging = true;
    learningRequestApi.Request.changeRequestStatus(this.request.id, {
      statusId: this.status
    })
      .then(async res => {
        //@ts-ignore
        this.request = res.data;
        await this.$store.dispatch("successToast", {
          message: `${this.$tc(this.$translate.Success)}`
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        //@ts-ignore
        this.status = this.request.statusId;
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })

      .finally(() => {
        this.isStatusChanging = false;
      });
  }

  async getStudents() {
    try {
      let params: StudentsListParams = {
        ids: this.request.studentIds
      };
      const { data } = await students(params);
      this.students = data.items;
      this.$emit("student", this.students);
    } catch (e) {
      throw new Error(e);
    }
  }

  goToProfile() {
    api.EmployeeApi.get(this.companyId, this.request.responsibleId).then(
      (res: { data: IEmployee }) => {
        this.$router.push({
          name: "userProfileView",
          params: { id: res.data.user.id }
        });
      }
    );
  }

  async mounted() {
    await this.getProfile();
    await this.getStudents();
  }
}
